/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { teal, green, lime } from '@material-ui/core/colors';
import {
  AttachMoney,
  MoneyOff,
  Money,
  Category,
  ShoppingBasket,
  ListAlt,
  PeopleOutline,
  Payment,
} from '@material-ui/icons';
import Card from '../Card';

const Home = ({ commonData }) => {
  const { currencyInfo } = useSelector(state => state);
  const { currency } = currencyInfo || {};
  const {
    totalCheck,
    totalAmount,
    totalGuest,
    totalCategory,
    totalItem,
    totalPaidAmount,
    totalTipAmount,
    totalUnpaidAmount,
  } = commonData;

  const list1 = [
    { label: 'Checks', value: totalCheck, icon: ListAlt },
    { label: 'Total', value: `${currency}${totalAmount.toFixed(2)}`, icon: AttachMoney },
    { label: 'Guests', value: totalGuest, icon: PeopleOutline },
  ];
  const list2 = [
    { label: 'Categories', value: totalCategory, icon: Category },
    { label: 'Items', value: totalItem, icon: ShoppingBasket },
  ];
  const list3 = [
    { label: 'Payment', value: `${currency}${totalPaidAmount.toFixed(2)}`, icon: Payment },
    { label: 'Tip', value: `${currency}${totalTipAmount.toFixed(2)}`, icon: Money },
    { label: 'Unpaid', value: `${currency}${totalUnpaidAmount.toFixed(2)}`, icon: MoneyOff },
  ];

  return (
    <React.Fragment>
      <Grid container>
        {list1.map((card, i) =>
          <Grid item xs={12} sm={6} md={4} lg={3} key={`key-${card.label}-${card.value}`}>
            <Card
              label={card.label}
              value={card.value}
              icon={card.icon}
              backgroundColor={teal[500]}
            />
          </Grid>
        )}
      </Grid>
      <Grid container>
        {list2.map((card, i) =>
          <Grid item xs={12} sm={6} md={4} lg={3} key={`key-${card.label}-${card.value}`}>
            <Card
              label={card.label}
              value={card.value}
              icon={card.icon}
              backgroundColor={green[500]}
            />
          </Grid>
        )}
      </Grid>
      <Grid container>
        {list3.map((card, i) =>
          <Grid item xs={12} sm={6} md={4} lg={3} key={`key-${card.label}-${card.value}`}>
            <Card
              label={card.label}
              value={card.value}
              icon={card.icon}
              backgroundColor={lime[500]}
            />
          </Grid>
        )}
      </Grid>
    </React.Fragment >
  );
};

export default Home;
